import { Grid } from '@material-ui/core';

// locals
import { useInputChangeHandler } from 'app/hooks';
import { Constants } from 'app/utils';
import { FormInput, CustomDatePicker, FormBasicSelect, MaskedInput } from '../../atoms';

const FilterOrders = ({ handleChange }) => {
  const {
    values,
    handleFilterInputChange,
    preventNonSpecialDebounceInput,
    preventNonNumericDebounceInput,
    handlePhoneInput
  } = useInputChangeHandler(handleChange);

  return (
    <>
      <Grid container spacing={3} className="items-center mt-8">
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <CustomDatePicker
            id="order_min_date"
            name="min_order_date"
            label="Başlangıç Tarihi"
            placeholder="Başlangıç tarihi"
            value={values?.min_order_date || ''}
            maxDate={values?.max_order_date || new Date('2100-01-01')}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <CustomDatePicker
            id="order_max_date"
            name="max_order_date"
            label="Bitiş Tarihi"
            placeholder="Bitiş tarihi"
            value={values?.max_order_date || ''}
            minDate={values?.min_order_date || new Date('1900-01-01')}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormInput
            id="order_user_name"
            name="name"
            placeholder="Ad"
            label="Ad"
            onChange={preventNonSpecialDebounceInput}
            maxLength={50}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormInput
            id="order_user_surname"
            name="surname"
            placeholder="Soyad"
            label="Soyad"
            onChange={preventNonSpecialDebounceInput}
            maxLength={50}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormInput
            id="order_pharmacy_name"
            name="pharmacy_name"
            label="Eczane Adı"
            placeholder="Eczane adı"
            onChange={preventNonSpecialDebounceInput}
            maxLength={50}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <MaskedInput
            type="text"
            mask="+\90 \(999\) 999 99 99"
            maskChar="_"
            alwaysShowMask
            id="id_telephone"
            name="telephone"
            placeholder="Cep Telefonu"
            label="Cep Telefonu"
            onChange={handlePhoneInput}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormInput
            id="_order_no"
            name="order_no"
            placeholder="Sipariş No"
            label="Sipariş No"
            onChange={preventNonNumericDebounceInput}
            maxLength={10}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormBasicSelect
            initialOptText="Tümü"
            id="order_statuses_id"
            name="order_statuses"
            label="Sipariş Durumu"
            value={values?.order_statuses}
            options={Constants.orderStatuses}
            onChange={handleFilterInputChange}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default FilterOrders;
